import _defineProperty from "/home/kamaleddin/apps/coolpic-site/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/home/kamaleddin/apps/coolpic-site/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["as", "children", "icon", "active", "label", "labelColor", "className"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { forwardRef, useId } from 'react';
import { Badge } from '../Badge';
import { useTheme } from '../Flowbite/ThemeContext';
import { Tooltip } from '../Tooltip';
import { useSidebarContext } from './SidebarContext';
import { useSidebarItemContext } from './SidebarItemContext';
var SidebarItem = forwardRef(function (_ref, ref) {
  var _children$charAt$toLo;
  var _ref$as = _ref.as,
    Component = _ref$as === void 0 ? 'a' : _ref$as,
    children = _ref.children,
    Icon = _ref.icon,
    isActive = _ref.active,
    label = _ref.label,
    _ref$labelColor = _ref.labelColor,
    labelColor = _ref$labelColor === void 0 ? 'info' : _ref$labelColor,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  var id = useId();
  var _useSidebarContext = useSidebarContext(),
    isCollapsed = _useSidebarContext.isCollapsed;
  var _useSidebarItemContex = useSidebarItemContext(),
    isInsideCollapse = _useSidebarItemContex.isInsideCollapse;
  var theme = useTheme().theme.sidebar.item;
  var ListItem = function ListItem(_ref2) {
    var wrapperChildren = _ref2.children;
    return _jsx("li", {
      children: isCollapsed ? _jsx(Tooltip, {
        content: _jsx(TooltipContent, {
          children: children
        }),
        placement: "right",
        children: wrapperChildren
      }) : wrapperChildren
    });
  };
  var TooltipContent = function TooltipContent(_ref3) {
    var children = _ref3.children;
    return _jsx(Children, {
      children: children
    });
  };
  var Children = function Children(_ref4) {
    var children = _ref4.children;
    return _jsx("span", {
      className: classNames(theme.content.base),
      "data-testid": "flowbite-sidebar-item-content",
      id: "flowbite-sidebar-item-".concat(id),
      children: children
    });
  };
  return _jsx(ListItem, {
    children: _jsxs(Component, _objectSpread(_objectSpread({
      "aria-labelledby": "flowbite-sidebar-item-".concat(id),
      className: classNames(theme.base, isActive && theme.active, !isCollapsed && isInsideCollapse && theme.collapsed.insideCollapse, className),
      ref: ref
    }, props), {}, {
      children: [Icon && _jsx(Icon, {
        "aria-hidden": true,
        className: classNames(theme.icon.base, isActive && theme.icon.active),
        "data-testid": "flowbite-sidebar-item-icon"
      }), isCollapsed && !Icon && _jsx("span", {
        className: theme.collapsed.noIcon,
        children: (_children$charAt$toLo = children.charAt(0).toLocaleUpperCase()) !== null && _children$charAt$toLo !== void 0 ? _children$charAt$toLo : '?'
      }), !isCollapsed && _jsx(Children, {
        children: children
      }), !isCollapsed && label && _jsx(Badge, {
        color: labelColor,
        "data-testid": "flowbite-sidebar-label",
        hidden: isCollapsed,
        className: theme.label,
        children: label
      })]
    }))
  });
});
SidebarItem.displayName = 'Sidebar.Item';
export default SidebarItem;